import AuthService from '../../utilities/services/auth.service'
import { AttendanceIntelligenceWrapper } from '../../components'

export default function AttendanceIntelligencePage() {
  const organization = AuthService.getOrg()[0]

  return <AttendanceIntelligenceWrapper organization={organization} />
}
